
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.962 11.655a18.496 18.496 0 00-14.708 7.268v-5.655a.826.826 0 00-.83-.826c-.46 0-.83.368-.83.826v8.671c0 .458.37.827.83.827h8.709a.826.826 0 100-1.653h-7.4a16.827 16.827 0 0114.218-7.805c9.269 0 16.808 7.506 16.808 16.735 0 9.23-7.539 16.736-16.808 16.736-4.789 0-9.368-2.051-12.558-5.615a.837.837 0 00-1.17-.07.828.828 0 00-.07 1.165 18.521 18.521 0 0013.798 6.172c10.189 0 18.468-8.253 18.468-18.388 0-10.135-8.28-18.388-18.457-18.388z"}})])
          )
        }
      }
    